import service from '@/store/services/workshop/spare_part_threshold-service';

const state = {
  list: {},
  spare_part_threshold: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, spare_part_threshold) => {
    state.spare_part_threshold = spare_part_threshold;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },
  
  list_threshold_master_id({commit, dispatch}, params) {
    return service.list_threshold_master_id(params)
    .then(({list, meta}) => {
      commit('SET_LIST', list);
      commit('SET_META', meta);
    });
  },

  list_lowest_threshold_master_id({commit, dispatch}, params) {
    return service.list_lowest_threshold_master_id(params)
    .then(({list, meta}) => {
      commit('SET_LIST', list);
      commit('SET_META', meta);
    });
  },

  list_threshold_dealer_id({commit, dispatch}, params) {
    return service.list_threshold_dealer_id(params)
    .then(({list, meta}) => {
      commit('SET_LIST', list);
      commit('SET_META', meta);
    });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((spare_part_threshold) => { commit('SET_RESOURCE', spare_part_threshold); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((spare_part_threshold) => { commit('SET_RESOURCE', spare_part_threshold); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((spare_part_threshold) => { commit('SET_RESOURCE', spare_part_threshold); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  spare_part_threshold: state => state.spare_part_threshold,
  page: state => state.meta.page,

};
 
const spare_part_threshold = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default spare_part_threshold;
